import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getEntityTownTypeCombo from '../../services/dossier/get/getEntityTownTypeCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchEntityTownTypeCombo ({ cityId, resolve }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = []
    if (cityId !== -1) {
      combo = yield call(getEntityTownTypeCombo, auth.token, cityId)
    }
    if (resolve) {
      resolve(combo)
    } else {
      yield put(fetchCombosSuccess({ entityTownTypeCombo: combo }))
    }
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchEntityTownTypeCombo () {
  yield takeEvery(combosActionTypes.FETCH_ENTITY_TOWN_COMBO, fetchEntityTownTypeCombo)
}
